module.exports = __webpack_public_path__ + "static/media/prepared.3887d39b.svg";